import "@sms/design-system/tokens/global.css";

// Standalone entry — `pnpm dev` from this directory renders one
// feature at a time. The shell host federates these surfaces directly.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { DashboardWidget } from "./features/dashboard/DashboardWidget";

const root = document.getElementById("root");
if (!root) throw new Error("admin-app: #root missing in index.html");

createRoot(root).render(
  <StrictMode>
    <DashboardWidget locale="ne" />
  </StrictMode>,
);
